// extracted by mini-css-extract-plugin
module.exports = {"FiltersWrap":"DisplaySort_FiltersWrap__s0khs","SortItem":"DisplaySort_SortItem__16KIs"};